import React from 'react';
// import dalePhoto from '../img/wigs_comp.jpg'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import angleDown from '@fortawesome/fontawesome-free-solid/faAngleDown'
import angleUp from '@fortawesome/fontawesome-free-solid/faAngleUp'
import { Power4 } from "gsap";

import WithAnimation from './WithAnimation'

import '../css/Stories.css'
// import AvatarBox from './AvatarBox'

class Stories extends WithAnimation {
   constructor(props) {
    super(props);

    this.readMoreToggle = this.readMoreToggle.bind(this)
    this.state = { isOpen: false }
  }

  componentDidMount() {
    this.Timeline.to('#story-1', 1, {height: "1250px", ease: Power4.easeInOut})
  }
  
  readMoreToggle() {
    const { isOpen } = this.state
    if(isOpen) {
      this.animationReverse()
    } else {
      this.animationStart()  
    }

    this.setState(({ isOpen }) => ({ isOpen: !isOpen }))
  }

  render() {
    const { isOpen } = this.state;
    return (
      <div className="story-section">
      {/*<AvatarBox name="Dale Enman" title="Founder & Director" avatarPhoto={dalePhoto} />*/}
      <h4>Dale Enman</h4>
      <p>Founder and Director</p>
        <div className="story" id="story-1">
          <p style={{textAlign:"left", whiteSpace: "pre-wrap"}}>
          <i>“Supporting women with a breast cancer diagnosis is the passion behind All About You Lingerie and Wig Boutique. We strive to provide a caring environment with the best selection of quality products, so every woman leaves here feeling confident.”</i><br /><br />

            In 2008 I developed Alopecia Universalis, causing me to lose all of my hair. My experience shopping for wigs was frustrating, to say the least. For example, having to make an appointment to see any wigs at all, which made me feel that I should buy, there was never a great selection in my style or color, high price points, having to pay for wigs before ordering and the staff /service was non existent when trying them on.  When travelling around North America, I would make it a point of visiting wig shops in search of something I liked and could afford. I have been asked to pay to try on wigs, I have been pressured to buy wigs I didn’t like, I was put out in the middle of stores to try them on…I’m bald remember, going bald in public was something I wasn’t doing at the time.  Yes, I was frustrated. <br />
<br />
            The lack of empathy or compassion from the staff that worked at the wig shops I visited became my inspiration to open my own shop.  I knew I was not getting my hair back, but I also knew I was not chronically ill. I thought about other women buying wigs who are fighting for their lives, and being treated the way I was, I knew I had to make a change.<br />
<br />
            I believe that all women deserve the same shopping experience, no matter our health, age, or figure. Being able to just walk into a store and choose from a wide selection of beautiful, high-quality products in a space we feel comfortable and well taken care of should not apply to only the healthy. <br />
<br />
            My initial plan was to open a wig shop, where all women can enjoy trying on all the hairstyles they want in a supportive environment without any pressure. Then I started thinking about other products and services I could offer my customers with a cancer diagnosis and noticed that post-mastectomy shopping in Nova Scotia was seriously lacking. The options I did find required by appointment only and either at a persons’ house or at a pharmacy. These options create a feeling of pressure to buy, without great selections. I felt this needed to change, women in need of these specialized services should have a place that is comfortable, inviting, selection, quality and have the knowledgeable staff to provide mutually rewarding, products and service.<br />
<br />
            I was on my way to opening a lingerie and wig boutique in Bridgewater when I was diagnosed with breast cancer in 2017, putting my plans on hold until I was well enough to continue. During my treatments and recovery, a story I had heard years earlier kept creeping into my head about a little girl throwing starfish back into the sea, it goes something like this.<br />
<br />
            The Starfish Story is about a man who sees a little girl throwing starfish back into the ocean after a storm had passed, leaving thousands of them washed up on the shore. The man tells the little girl that there are too many to save and throwing them back won’t make a difference. The girl after she throws another starfish into the water, turns and says;  “it made a difference to that one”. I knew in my heart that this boutique was my way of throwing starfish back into the ocean. I want to help as many women living with a breast cancer diagnosis as possible and even though I can’t help them all, if I make a difference in just one woman’s life then I’ve succeeded.<br />
<br />
            The Starfish was also inspiring to me because of the ability starfish have to regenerate their limbs. I know I can’t grow my hair back or regenerate breasts for myself or other women, but my shop is using the starfish as a logo, to show that we strive to help women feel whole again. <br />
<br />
            Women are women, breast cancer or not, big or small, hair or no hair, we all want to look good. From lingerie and wigs, to prosthetics and cosmetics, swimsuits and clothing, my boutique is a space for women of all shapes, sizes, and stages of life to find the quality products and support they need. <br />
          </p>
          <div className="read-more" onClick={this.readMoreToggle}><br />{ isOpen ? <button>Read Less...<FontAwesomeIcon icon={angleUp} size="sm" className="plus-circle"/></button> : <button>Read More... <FontAwesomeIcon icon={angleDown} size="sm" className="plus-circle"/></button>}</div>
        </div>
      </div>
    );
  }
}

export default Stories;



// WEBPACK FOOTER //
// ./src/components/Stories.js